module.exports = __webpack_public_path__ + "static/media/AZ.fa9c079d.svg";